import { Coordinate } from '../types/graphQLTypes';

export default function getGoogleMapsLink(coordinate: Coordinate) {
  return `https://www.google.com/maps/search/?api=1&query=${coordinate[1].toFixed(7)}%2C${coordinate[0].toFixed(7)}`;
}
